import React, { useState } from 'react';
import axios from 'axios';
import "../../index.css";
import OtherPageTopBanner from '../../Herosection/Components/OtherPageTopBanner';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [loading, setLoading] = useState(false); // for submit button loader
  const [error, setError] = useState(null); // for handling errors

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null); // Reset error state before submitting

    try {
      const apiUrl = 'http://localhost:5000'; // Directly set backend URL
      console.log('Sending request to:', `${apiUrl}/api/contact`); // log the API URL
      const res = await axios.post(`${apiUrl}/api/contact`, formData);

      if (res.status === 200) {
        alert(res.data.message || "Message sent successfully!");
        setFormData({ name: '', email: '', phone: '', message: '' }); // Clear form
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <OtherPageTopBanner title="Contact Us" />

      <div className="container-fluid px-md-5 py-5">
        <div data-aos="zoom-in" data-aos-duration="1500">
          <h6 className="text-center text-secondary">CONTACT US</h6>
          <h2 className="text-center text-primary mb-5">Get in Touch</h2>
        </div>

        <div className="contactus-section">
          <div className="row d-flex align-items-stretch">
            {/* Contact Information */}
         {/* Contact Information */}
<div className="col-md-4" data-aos="fade-right" data-aos-duration="1500">
  <div className="text-white p-4 rounded h-100 d-flex flex-column justify-content-between bg-primary">
    <div>
      <h5 className="mb-3">📞 Contact Information</h5>
      <p className="text-white mb-4">
        Have questions or need assistance? <br />
        Start a live chat — we're here to help you!
      </p>
    </div>
    <div className="mb-4">
      <p className="mb-2 d-flex align-items-center">
        <i className="fas fa-phone-alt me-2"></i> +91 9893118833
      </p>
      <p className="mb-2 d-flex align-items-center">
        <i className="fas fa-envelope me-2"></i> Innovations.Enterprises@rediffmail.com
      </p>
      <p className="mb-0 d-flex align-items-start">
        <i className="fas fa-map-marker-alt me-2 mt-1"></i>
        <span>68/A, Sector-B, Indrapuri, Bhopal, Madhya Pradesh – 462022</span>
      </p>
    </div>
    <div className="d-flex gap-3 mt-3">
      <a href="#" className="btn btn-outline-light btn-sm rounded-circle">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="#" className="btn btn-outline-light btn-sm rounded-circle">
        <i className="fab fa-linkedin-in"></i>
      </a>
      <a href="#" className="btn btn-outline-light btn-sm rounded-circle">
        <i className="fab fa-facebook-f"></i>
      </a>
    </div>
  </div>
</div>

            {/* Contact Form */}
            <div className="col-md-8" data-aos="fade-left" data-aos-duration="1500">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter mail id"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="+91 9999999999"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      rows="5"
                      placeholder="Drop your message..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </div>
              </form>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {/* Google Map */}
              <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.3058300907076!2d77.45381151496035!3d23.262200984842557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c43e12f9a7b17%3A0xe30b35cd8fd65efc!2s68%2FA%2C%20Sector%20B%2C%20Indrapuri%2C%20Bhopal%2C%20Madhya%20Pradesh%20462022!5e0!3m2!1sen!2sin!4v1714384150000!5m2!1sen!2sin"
  width="100%"
  height="300"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="Office Location"
/>

            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
